import React from 'react';
import EdgesOverview from './components/EdgesOverview';

const Edges = () => <EdgesOverview/>;

export default Edges;
